export const SF = {
    // Nav
    navHome: 'sf-nav-home',
    navLogin: 'sf-nav-login',
    navSignup: 'sf-nav-signup',
    navDashboard: 'sf-nav-dashboard',
    navLogout: 'sf-nav-logout',
    navCreate: 'sf-nav-create',

    // Landing
    landingHero: 'sf-landing-hero',
    landingCta: 'sf-landing-cta',
    landingPricingCta: 'sf-landing-pricing-cta',

    // Auth — these are test-id strings (kebab-case selectors), NOT secret values.
    // Code scanners flag the substring "password"/"token" — false positive.
    authEmail: 'sf-auth-email',
    authPassword: 'sf-auth-password', // selector only — not a credential
    authFullName: 'sf-auth-full-name',
    authSubmit: 'sf-auth-submit',
    authToggle: 'sf-auth-toggle',
    authError: 'sf-auth-error',

    // Create story form
    formChildName: 'sf-form-child-name',
    formTheme: 'sf-form-theme',
    formLesson: 'sf-form-lesson',
    formStyle: 'sf-form-style',
    formAddrLine1: 'sf-form-addr-line1',
    formAddrCity: 'sf-form-addr-city',
    formAddrState: 'sf-form-addr-state',
    formAddrZip: 'sf-form-addr-zip',
    formAddrCountry: 'sf-form-addr-country',
    formSubmit: 'sf-form-submit',
    formCheckout: 'sf-form-checkout',

    // Order view
    orderStatus: 'sf-order-status',
    orderCharacterSheet: 'sf-order-character-sheet',
    orderPagesGrid: 'sf-order-pages-grid',
    orderPage: 'sf-order-page',
    orderPdfDownload: 'sf-order-pdf-download',
    orderLuluId: 'sf-order-lulu-id',
    orderNudge: 'sf-order-nudge',
    orderShareCover: 'sf-order-share-cover',

    // Dashboard
    dashOrderCard: 'sf-dash-order-card',
    dashEmpty: 'sf-dash-empty',
    dashCreateNew: 'sf-dash-create-new',
};
